import { useTarget } from "lib/@hooks/use-target"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Box, Checkbox, ListItem, ListItemText, Stack, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { getLocalSchedule } from "routes/sfg20-admin/plugins/client-migration-tab/plugins/move-schedules/controller/get-local-schedule"

export function MovableSchedule({ item }) {
    const { selected } = useTarget()
    const { refresh } = useBoundContext()
    return (
        <ListItem>
            <ListItemBox>
                <Checkbox
                    checked={selected[item.id] ?? false}
                    onChange={() => {
                        refresh()
                        return (selected[item.id] = !selected[item.id])
                    }}
                />
                <Box flex={1}>
                    <ListItemText primary={item.title} secondary={item.code} />
                </Box>
                <Box>
                    <IsMapped scheduleId={item.id} />
                </Box>
            </ListItemBox>
        </ListItem>
    )
}

function IsMapped({ scheduleId }) {
    const localSchedule = getLocalSchedule.useResults(scheduleId)
    return (
        !!localSchedule && (
            <Stack direction="row">
                <Typography variant="body2" color="text.secondary">
                    imported locally as #{localSchedule?.code}
                </Typography>
            </Stack>
        )
    )
}
